<!-- <app-master-navbar></app-master-navbar> -->
<app-nav-logo></app-nav-logo>

<div class="content">
    <div class="container-fuild">
        <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 text-center
                mt-5">
                <h4 class="font-weight-bold">"ข้อมูลจังหวัด {{provinceName}}"</h4>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-3 col-sm-12 col-xs-12"></div>
            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12
                text-center
                mt-3 tab">
                <ul class="nav nav-tabs col-xl-12">
                    <li class="">
                        <a class="" id="Info" [ngClass]="(Info == true)?'active' : ''"
                            (click)="select_Info($event.target.id)">ภาพรวมจังหวัด</a>
                    </li>
                    <li class="">
                        <a class="" id="List" [ngClass]="(List == true)?'active' : ''"
                            (click)="select_List($event.target.id)">รายชื่อสหกรณ์ของจังหวัด</a>
                    </li>
                </ul>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-3 col-sm-12 col-xs-12"></div>
        </div>
    </div>

    <div class="container-fuild p-4">
        <ng-container *ngIf="Info">

            <div class="row">
                <div class="col-xl-12">
                    <div class="content-tab">
                        <!-- Nav pills -->
                        <ul class="nav nav-pills" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active" data-toggle="pill" href="#info">ข้อมูลทั่วไป</a>
                            </li>
                            <!-- <li class="nav-item">
                                <a class="nav-link" data-toggle="pill" href="#asset_">อุปกรณ์การตลาด</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" data-toggle="pill" href="#machine_">เครื่องจักรกลการเกษตร</a>
                            </li> -->
                        </ul>

                        <!-- Tab panes -->
                        <div class="container-fluid">
                            <div class="row">
                                <div class="tab-content">
                                    <div id="info" class="tab-pane active">
                                        <div class="container-fluid mb-2">

                                            <div class="row mt-4">
                                                <div class="col" style="text-align: right;">
                                                    ภาคการเกษตร
                                                    <select class="form-select mr-3" name="list_sector" id="list_sector"
                                                        (change)="selectNewYearAndSector('',$event.target.value)"
                                                        [(ngModel)]="sector_now">
                                                        <option *ngFor="let x of listsector" value="{{x.value}}">
                                                            {{x.name}}</option>
                                                    </select>
                                                    ข้อมูล ณ ปี
                                                    <select class="form-select" name="list_year" id="list_year"
                                                        (change)="selectNewYearAndSector($event.target.value,'')"
                                                        [(ngModel)]="year_now">
                                                        <option *ngFor="let y of listYear" value="{{y}}">{{y}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 mt-4">
                                                    <div class="card h-100">
                                                        <div class="card-header pb-0">
                                                            <h6 class="font-weight-bold">จำนวนสหกรณ์
                                                            </h6>
                                                        </div>
                                                        <div class="card-body">
                                                            <div class="row p-0 m-0">
                                                                <div class="col-xl-12">
                                                                    <h6 class="text-center p-2 mt-3">ข้อมูล ณ
                                                                        วันที่
                                                                        {{Date_after_day}} {{Month_now_}}
                                                                        {{year_now_}}
                                                                    </h6>
                                                                </div>
                                                                <div class="col-xl-12 col-md-12 col-sm-12 d-flex">
                                                                    <div class="col-xl-4 col-lg-4 col-md-4">
                                                                        <img src="/assets/images/vegetables.png"
                                                                            class="w-100" alt="">
                                                                    </div>
                                                                    <div
                                                                        class="col-xl-8 col-lg-8 col-lg-8 text-center p-0">
                                                                        <span>สหกรณ์</span>
                                                                        <p class="content-user mt-auto mb-auto">
                                                                            {{CoopOracleCount |
                                                                            number:'':'he'}} แห่ง
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div id="chartdiv_AN"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 mt-4">
                                                    <div class="card h-100">
                                                        <div class="card-header pb-0">
                                                            <h6 class="font-weight-bold">จำนวนสมาชิกสหกรณ์
                                                            </h6>
                                                        </div>
                                                        <div class="card-body">
                                                            <div class="row p-0 mt-2 text-center">
                                                                <div class="col-xl-4">
                                                                    <img src="/assets/images/farmer-m.png"
                                                                        class="img-staff" alt="">
                                                                </div>
                                                                <div class="col-xl-8 mt-auto mb-auto">
                                                                    <span class="content-user2">เพศชาย</span>
                                                                    <p class="content-user3 mt-auto mb-auto">
                                                                        {{MemberYearDataM
                                                                        | number:'':'he'}} คน
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="row p-0 mt-4 text-center">
                                                                <div class="col-xl-4">
                                                                    <img src="/assets/images/farmer-fm.png"
                                                                        class="img-staff" alt="">
                                                                </div>
                                                                <div class="col-xl-8 mt-auto mb-auto">
                                                                    <span class="content-user2">เพศหญิง</span>
                                                                    <p class="content-user3 mt-auto mb-auto">
                                                                        {{MemberYearDataFm
                                                                        | number:'':'he'}} คน
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="row p-0 m-0">
                                                                <div class="col-xl-12 text-center mt-5">
                                                                    <span>สมาชิกรวม</span>
                                                                    <p class="content-user mt-auto mb-auto">
                                                                        {{MemberYearDataSum | number:'':'he'}} คน
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 mt-4">
                                                    <div class="card h-100">
                                                        <div class="card-header pb-0">
                                                            <h6 class="font-weight-bold">จำนวนกรรมการ
                                                            </h6>
                                                        </div>
                                                        <div class="card-body p-4">
                                                            <div class="row p-0 mt-2 text-center">
                                                                <div class="col-xl-4">
                                                                    <img src="/assets/images/employee1.png"
                                                                        class="img-staff" alt="">
                                                                </div>
                                                                <div class="col-xl-8 mt-auto mb-auto">
                                                                    <span class="content-user2">เพศชาย</span>
                                                                    <p class="content-user3 mt-auto mb-auto">
                                                                        {{CommitteeYearM
                                                                        | number:'':'he'}} คน
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="row p-0 mt-4 text-center">
                                                                <div class="col-xl-4">
                                                                    <img src="/assets/images/employee.png"
                                                                        class="img-staff" alt="">
                                                                </div>
                                                                <div class="col-xl-8 mt-auto mb-auto">
                                                                    <span class="content-user2">เพศหญิง</span>
                                                                    <p class="content-user3 mt-auto mb-auto">
                                                                        {{CommitteeYearFM
                                                                        | number:'':'he'}} คน
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="row p-0 m-0">
                                                                <div class="col-xl-12 text-center mt-5">
                                                                    <span>กรรมการ</span>
                                                                    <p class="content-user mt-auto mb-auto">
                                                                        {{CommitteeYear | number:'':'he'}} คน
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 mt-4">
                                                    <div class="card h-100">
                                                        <div class="card-header pb-0">
                                                            <h6 class="font-weight-bold">จำนวนเจ้าหน้าที่สหกรณ์
                                                            </h6>
                                                        </div>
                                                        <div class="card-body p-3">
                                                            <div class="row p-0 mt-2 text-center">
                                                                <div class="col-xl-4">
                                                                    <img src="/assets/images/steward.png"
                                                                        class="img-staff" alt="">
                                                                </div>
                                                                <div class="col-xl-8 mt-auto mb-auto">
                                                                    <span class="content-user2">เพศชาย</span>
                                                                    <p class="content-user3 mt-auto mb-auto">
                                                                        {{CoopOfficerYearMemberM
                                                                        | number:'':'he'}} คน
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="row p-0 mt-4 text-center">
                                                                <div class="col-xl-4">
                                                                    <img src="/assets/images/stewardess.png"
                                                                        class="img-staff" alt="">
                                                                </div>
                                                                <div class="col-xl-8 mt-auto mb-auto">
                                                                    <span class="content-user2">เพศหญิง</span>
                                                                    <p class="content-user3 mt-auto mb-auto">
                                                                        {{CoopOfficerYearMemberFm
                                                                        | number:'':'he'}} คน
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="row p-0 m-0">
                                                                <div class="col-xl-12 text-center mt-5">
                                                                    <span>พนักงาน</span>
                                                                    <p class="content-user mt-auto mb-auto">
                                                                        {{CoopOfficerYearMember |
                                                                        number:'':'he'}} คน
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
<!-- {{year_now}} -->
                                            <div class="row justify-content-center "   >
                                                <div class="col-xl-6 col-sm-12 mt-4" *ngIf="year_now<2567">
                                                    <div class="card h-100">
                                                        <div class="card-header">
                                                            <div class="col-lg-12
                                                            col-md-12">
                                                                <h6 class="font-weight-bold">มาตรฐานสหกรณ์</h6>
                                                            </div>
                                                        </div>
                                                        <div class="card-body">
                                                            <div class="col-xl-12 text-right">

                                                            </div>
                                                            <div *ngIf="!StandardTypeSumClose" id="chartdiv_Standard"> </div>
                                                            <div *ngIf="StandardTypeSumClose" style="margin-top: 8rem; text-align: center; margin-bottom: 8rem;"> ไม่พบข้อมูล</div>
                                                            <!-- <div class="col-xl-12 text-right">
                                                                <p>ที่มา : กรมส่งเสริมสหกรณ์</p>
                                                            </div> -->
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xl-6 col-sm-12 mt-4">
                                                    <div class="card
                                                    h-100">
                                                        <div class="card-header">
                                                            <div class="col-lg-12
                                                            col-md-12">
                                                                <h6 class="font-weight-bold">ระดับขั้นความเข้มแข็ง  </h6>
                                                            </div>
                                                        </div>
                                                        <div class="card-body">
                                                            <div class="col-xl-12 text-right">

                                                            </div>
                                                            <div *ngIf="!CoopLevelCountClose" id="chartdiv_Strong"> </div>
                                                            <div *ngIf="CoopLevelCountClose" style="margin-top: 8rem; text-align: center; margin-bottom: 8rem;"> ไม่พบข้อมูล</div>
                                                            <div class="d-none"
                                                                *ngFor="let items of standard; index as i">
                                                                <div *ngIf="i == 0">
                                                                    <div class="card-body
                                                                    p-3">
                                                                        <div class="col-xl-12
                                                                        col-lg-12
                                                                        col-md-12
                                                                        mt-3
                                                                        d-flex">
                                                                            <i class="fas
                                                                            fa-check-circle"></i>
                                                                            <p class="ml-3
                                                                            content-p
                                                                            mt-auto
                                                                            mb-auto" thousandSeparator=",">
                                                                                {{items.sum_standard_pass |
                                                                                number:'':'he'}} แห่ง
                                                                            </p>
                                                                            <span class="mt-auto
                                                                            mb-auto
                                                                            ml-2">({{persent_standard_pass|
                                                                                number:'2.1-2'}}
                                                                                %)</span>
                                                                        </div>
                                                                        <div class="col-xl-12
                                                                        col-lg-12
                                                                        col-md-12
                                                                        mt-4
                                                                        d-flex">
                                                                            <i class="fas
                                                                            fa-times-circle"></i>
                                                                            <p class="ml-3
                                                                            content-p
                                                                            mt-auto
                                                                            mb-auto" thousandSeparator=",">
                                                                                {{items.sum_standard_not |
                                                                                number:'':'he'}} แห่ง
                                                                            </p>
                                                                            <span class="mt-auto
                                                                            mb-auto
                                                                            ml-2">({{persent_standard_not
                                                                                |
                                                                                number:'2.1-2'}}
                                                                                %)</span>
                                                                        </div>
                                                                        <div class="col-lg-12
                                                                        col-md-12
                                                                        mt-4
                                                                        tex-center">
                                                                            <p class="ml-3
                                                                            mt-auto
                                                                            mb-auto
                                                                            tex-center
                                                                            total-sum" thousandSeparator=",">รวม
                                                                                {{sumstandard | number:'':'he'}} แห่ง
                                                                            </p>
                                                                        </div>
                                                                        <div class="col-lg-12">
                                                                            <hr>
                                                                            <div class="row
                                                                            mt-2">
                                                                                <div class="col-xl-12
                                                                                col-md-12
                                                                                col-sm-12
                                                                                col-xs-12
                                                                                d-flex">
                                                                                    <div class="bg-pass"></div>
                                                                                    <p class="m-0
                                                                                    pl-3">
                                                                                        ผ่านมาตรฐานสหกรณ์
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                            <div class="row
                                                                            mt-2">
                                                                                <div class="col-xl-12
                                                                                col-md-12
                                                                                col-sm-12
                                                                                col-xs-12
                                                                                d-flex">
                                                                                    <div class="bg-notpass"></div>
                                                                                    <p class="m-0
                                                                                    pl-3">
                                                                                        ไม่ผ่านมาตรฐานสหกรณ์
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <!-- <div class="col-lg-12
                                                                        col-md-12
                                                                        col-sm-12
                                                                        col-xs-12
                                                                        text-right
                                                                        p-3">
                                                                            <a href="/Coop-Standard">ดูเพิ่มเติม</a>
                                                                        </div> -->
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <!-- <div class="col-xl-12 text-right">
                                                                <p>ที่มา : กรมส่งเสริมสหกรณ์</p>
                                                            </div> -->
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                             <div class="row">
                                                <div class="col-xl-3 col-md-6 col-sm-12 mt-4" *ngIf="sector_now == 0">
                                                    <div class="card h-100">
                                                        <div class="card-header  pb-0">
                                                            <h6 class="font-weight-bold">จำนวนสหกรณ์ ทุกประเภท
                                                            </h6>
                                                        </div>
                                                        <div class="card-body">
                                                            <div class="col-xl-12">
                                                                <div class="table-responsive">
                                                                    <table class="table table-bordered m-0">
                                                                        <thead class="thead-light">
                                                                            <tr>
                                                                                <th colspan="2" class="text-center">
                                                                                    สถานะ</th>
                                                                                <th colspan="2" class="text-center"  *ngIf="year_now<2567">
                                                                                    มาตรฐาน</th>
                                                                            </tr>
                                                                            <tr>
                                                                                <th class="text-center table-success" >
                                                                                    Active</th>
                                                                                <th class="text-center table-danger">
                                                                                    Non-active</th>
                                                                                <th class="text-center table-success"  *ngIf="year_now<2567">
                                                                                    ผ่าน</th>
                                                                                <th class="text-center table-danger"  *ngIf="year_now<2567">
                                                                                    ไม่ผ่าน</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr>
                                                                                <td>{{Active_coopType1 |
                                                                                       number: '':'he'}}</td>
                                                                                <td>{{InActive_coopType1 |
                                                                                    number: '':'he'}}</td>
                                                                                <td *ngIf="!StandardTypeSumClose && year_now<2567">{{ StandardTypeSum_pass === 0 ? 'ไม่พบข้อมูล' : (StandardTypeSum_pass | number: '':'he') }}</td>
                                                                                <td *ngIf="!StandardTypeSumClose  && year_now<2567"> {{ StandardTypeSum_notPass === 0 ? 'ไม่พบข้อมูล' : (StandardTypeSum_notPass | number: '':'he') }}</td>
                                                                                <td *ngIf="StandardTypeSumClose  && year_now<2567">ไม่พบข้อมูล</td>
                                                                                <td *ngIf="StandardTypeSumClose  && year_now<2567">ไม่พบข้อมูล</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                    <table class="table table-bordered">
                                                                        <thead class="thead-light">
                                                                            <tr>
                                                                                <th colspan="4" class="text-center">
                                                                                    ระดับขั้นความเข้มแข็ง</th>
                                                                            </tr>
                                                                            <tr>
                                                                                <th class="text-center">
                                                                                    ชั้นที่ 1</th>
                                                                                <th class="text-center">
                                                                                    ชั้นที่ 2</th>
                                                                                <th class="text-center">
                                                                                    ชั้นที่ 3</th>
                                                                                <th class="text-center"
                                                                                    *ngIf="year_now < 2565">
                                                                                    ชั้นที่ 4</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr>
                                                                                <td>{{TypeLevelSum1 |
                                                                                    number:'':'he'}}
                                                                                </td>
                                                                                <td>{{TypeLevelSum2 |
                                                                                    number:'':'he'}}
                                                                                </td>
                                                                                <td>{{TypeLevelSum3 |
                                                                                    number:'':'he'}}
                                                                                </td>
                                                                                <td *ngIf="year_now < 2565">
                                                                                    {{TypeLevelSum4 |
                                                                                    number:'':'he'}}
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <ng-container *ngFor="let items of CoopOracleTypes ; let i = index;">
                                                    <div class="col-xl-3 col-md-6 col-sm-12 mt-4"
                                                    *ngIf="((sector_now == 0 || sector_now == 1) && (items.coopType == '1' || items.coopType == '2' || items.coopType == '3'))
                                                        || ((sector_now == 0 || sector_now == 2) && (items.coopType == '4' || items.coopType == '5' || items.coopType == '6' || items.coopType == '7'))">
                                                        <div class="card h-100"
                                                            *ngIf="items.coopType == '1' || items.coopType == '2' || items.coopType == '3' || items.coopType == '4' || items.coopType == '5' || items.coopType == '6' || items.coopType == '7'">
                                                            <div class="card-header pb-0">
                                                                <h6 class="font-weight-bold" *ngIf="items.coopType  == '1'">
                                                                    จำนวนสหกรณ์
                                                                    ประเภทสหกรณ์การเกษตร
                                                                </h6>
                                                                <h6 class="font-weight-bold" *ngIf="items.coopType == '2'">
                                                                    จำนวนสหกรณ์
                                                                    ประเภทสหกรณ์ประมง
                                                                </h6>
                                                                <h6 class="font-weight-bold" *ngIf="items.coopType == '3'">
                                                                    จำนวนสหกรณ์
                                                                    ประเภทสหกรณ์นิคม
                                                                </h6>
                                                                <h6 class="font-weight-bold" *ngIf="items.coopType == '4'">
                                                                    จำนวนสหกรณ์
                                                                    ประเภทสหกรณ์ออมทรัพย์
                                                                </h6>
                                                                <h6 class="font-weight-bold" *ngIf="items.coopType == '5'">
                                                                    จำนวนสหกรณ์
                                                                    ประเภทสหกรณ์ร้านค้า
                                                                </h6>
                                                                <h6 class="font-weight-bold" *ngIf="items.coopType == '6'">
                                                                    จำนวนสหกรณ์
                                                                    ประเภทสหกรณ์บริการ
                                                                </h6>
                                                                <h6 class="font-weight-bold" *ngIf="items.coopType == '7'">
                                                                    จำนวนสหกรณ์
                                                                    ประเภทสหกรณ์เครดิตยูเนี่ยน
                                                                </h6>
                                                            </div>
                                                            <div class="card-body">
                                                                <div class="col-xl-12">
                                                                    <div class="table-responsive">
                                                                        <table class="table table-bordered m-0">
                                                                            <thead class="thead-light">
                                                                                <tr>
                                                                                    <th colspan="2" class="text-center">
                                                                                        สถานะ</th>
                                                                                    <th colspan="2" class="text-center" *ngIf="year_now<2567">
                                                                                        มาตรฐาน</th>
                                                                                </tr>
                                                                                <tr>
                                                                                    <th class="text-center table-success">
                                                                                        Active</th>
                                                                                    <th class="text-center table-danger">
                                                                                        Non-active</th>
                                                                                    <th class="text-center table-success" *ngIf="year_now<2567">
                                                                                        ผ่าน</th>
                                                                                    <th class="text-center table-danger" *ngIf="year_now<2567">
                                                                                        ไม่ผ่าน</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td>{{items.active |
                                                                                        number:'':'he'}}
                                                                                    </td>
                                                                                    <td>{{items.nonActive |
                                                                                        number:'':'he'}}
                                                                                    </td>

                                                                                           <td *ngIf="items.coopType == '1' &&  year_now<2567">
                                                                                    {{StandardType_pass_level1  == 0 ? 'ไม่พบข้อมูล' :  (StandardType_pass_level1 | number: '':'he') }}</td>
                                                                                <td *ngIf="items.coopType == '1' &&  year_now<2567">
                                                                                    {{StandardType_notPass_level1   == 0 ? 'ไม่พบข้อมูล' :(StandardType_notPass_level1 | number:'':'he')  }}</td>
                                                                                <td *ngIf="items.coopType == '2' &&  year_now<2567">
                                                                                    {{StandardType_pass_level2  == 0 ? 'ไม่พบข้อมูล' :(StandardType_pass_level2 | number:'':'he' )}}</td>
                                                                                <td *ngIf="items.coopType == '2' &&  year_now<2567">
                                                                                    {{StandardType_notPass_level2  == 0 ? 'ไม่พบข้อมูล' :(StandardType_notPass_level2 | number:'':'he')}}</td>
                                                                                <td *ngIf="items.coopType == '3'&&  year_now<2567">
                                                                                    {{StandardType_pass_level3   == 0 ? 'ไม่พบข้อมูล' :(StandardType_pass_level3 |number:'':'he' )}}</td>
                                                                                <td *ngIf="items.coopType == '3' && year_now<2567">
                                                                                    {{StandardType_notPass_level3   == 0 ? 'ไม่พบข้อมูล' :(StandardType_notPass_level3 |number:'':'he')}}</td>
                                                                                <td *ngIf="items.coopType == '4' &&  year_now<2567">
                                                                                    {{StandardType_pass_level4  == 0 ? 'ไม่พบข้อมูล' :(StandardType_pass_level4 | number:'':'he')}}</td>
                                                                                <td *ngIf="items.coopType == '4' &&  year_now<2567">
                                                                                    {{StandardType_notPass_level4   == 0 ? 'ไม่พบข้อมูล' :(StandardType_notPass_level4 |number:'':'he')}}</td>
                                                                                <td *ngIf="items.coopType == '5' &&  year_now<2567">
                                                                                    {{StandardType_pass_level5  == 0 ? 'ไม่พบข้อมูล' :(StandardType_pass_level5 |number:'':'he')}}</td>
                                                                                <td *ngIf="items.coopType == '5' &&  year_now<2567">
                                                                                    {{StandardType_notPass_level5  == 0 ? 'ไม่พบข้อมูล' :(StandardType_notPass_level5 |number:'':'he')}}</td>
                                                                                <td *ngIf="items.coopType == '6' &&  year_now<2567">
                                                                                  {{StandardType_pass_level6  == 0 ? 'ไม่พบข้อมูล' :(StandardType_pass_level6 |number:'':'he')}}</td>
                                                                                <td *ngIf="items.coopType == '6' &&  year_now<2567">
                                                                                    {{StandardType_notPass_level6   == 0 ? 'ไม่พบข้อมูล' :(StandardType_notPass_level6 |number:'':'he' )}}</td>
                                                                                <td *ngIf="items.coopType == '7' &&  year_now<2567">
                                                                                    {{StandardType_pass_level7   == 0 ? 'ไม่พบข้อมูล' :(StandardType_pass_level7 |number:'':'he' )}}</td>
                                                                                <td *ngIf="items.coopType == '7' &&  year_now<2567">
                                                                                    {{StandardType_notPass_level7  == 0 ? 'ไม่พบข้อมูล' :(StandardType_notPass_level7 |number:'':'he')}}</td>


                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                        <table class="table table-bordered">
                                                                            <thead class="thead-light">
                                                                                <tr>
                                                                                    <th colspan="4" class="text-center">
                                                                                        ระดับขั้นความเข้มแข็ง</th>
                                                                                </tr>
                                                                                <tr>
                                                                                    <th class="text-center">
                                                                                        ชั้นที่ 1</th>
                                                                                    <th class="text-center">
                                                                                        ชั้นที่ 2</th>
                                                                                    <th class="text-center">
                                                                                        ชั้นที่ 3</th>
                                                                                    <th class="text-center"
                                                                                        *ngIf="year_now < 2565">
                                                                                        ชั้นที่ 4</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td *ngIf="items.coopType == '1' ">
                                                                                        {{TypeLevel1_type1 |
                                                                                        number:'':'he'}}
                                                                                    </td>
                                                                                    <td *ngIf="items.coopType == '2' ">
                                                                                        {{TypeLevel1_type2 |
                                                                                        number:'':'he'}}
                                                                                    </td>
                                                                                    <td *ngIf="items.coopType == '3' ">
                                                                                        {{TypeLevel1_type3 |
                                                                                        number:'':'he'}}
                                                                                    </td>
                                                                                    <td *ngIf="items.coopType == '4' ">
                                                                                        {{TypeLevel1_type4 |
                                                                                        number:'':'he'}}
                                                                                    </td>
                                                                                    <td *ngIf="items.coopType == '5' ">
                                                                                        {{TypeLevel1_type5 |
                                                                                        number:'':'he'}}
                                                                                    </td>
                                                                                    <td *ngIf="items.coopType == '6' ">
                                                                                        {{TypeLevel1_type6 |
                                                                                        number:'':'he'}}
                                                                                    </td>
                                                                                    <td *ngIf="items.coopType == '7' ">
                                                                                        {{TypeLevel1_type7 |
                                                                                        number:'':'he'}}
                                                                                    </td>
                                                                                    <td *ngIf="items.coopType == '1' ">
                                                                                        {{TypeLevel2_type1 |
                                                                                        number:'':'he'}}
                                                                                    </td>
                                                                                    <td *ngIf="items.coopType == '2' ">
                                                                                        {{TypeLevel2_type2 |
                                                                                        number:'':'he'}}
                                                                                    </td>
                                                                                    <td *ngIf="items.coopType == '3' ">
                                                                                        {{TypeLevel2_type3 |
                                                                                        number:'':'he'}}
                                                                                    </td>
                                                                                    <td *ngIf="items.coopType == '4' ">
                                                                                        {{TypeLevel2_type4 |
                                                                                        number:'':'he'}}
                                                                                    </td>
                                                                                    <td *ngIf="items.coopType == '5' ">
                                                                                        {{TypeLevel2_type5 |
                                                                                        number:'':'he'}}
                                                                                    </td>
                                                                                    <td *ngIf="items.coopType == '6' ">
                                                                                        {{TypeLevel2_type6 |
                                                                                        number:'':'he'}}
                                                                                    </td>
                                                                                    <td *ngIf="items.coopType == '7' ">
                                                                                        {{TypeLevel2_type7 |
                                                                                        number:'':'he'}}
                                                                                    </td>
                                                                                    <td *ngIf="items.coopType == '1' ">
                                                                                        {{TypeLevel3_type1 |
                                                                                        number:'':'he'}}
                                                                                    </td>
                                                                                    <td *ngIf="items.coopType == '2' ">
                                                                                        {{TypeLevel3_type2 |
                                                                                        number:'':'he'}}
                                                                                    </td>
                                                                                    <td *ngIf="items.coopType == '3' ">
                                                                                        {{TypeLevel3_type3 |
                                                                                        number:'':'he'}}
                                                                                    </td>
                                                                                    <td *ngIf="items.coopType == '4' ">
                                                                                        {{TypeLevel3_type4 |
                                                                                        number:'':'he'}}
                                                                                    </td>
                                                                                    <td *ngIf="items.coopType == '5' ">
                                                                                        {{TypeLevel3_type5 |
                                                                                        number:'':'he'}}
                                                                                    </td>
                                                                                    <td *ngIf="items.coopType == '6' ">
                                                                                        {{TypeLevel3_type6 |
                                                                                        number:'':'he'}}
                                                                                    </td>
                                                                                    <td *ngIf="items.coopType == '7' ">
                                                                                        {{TypeLevel3_type7 |
                                                                                        number:'':'he'}}
                                                                                    </td>
                                                                                    <td
                                                                                        *ngIf="items.coopType == '1' && year_now < 2565 ">
                                                                                        {{TypeLevel4_type1 |
                                                                                        number:'':'he'}}
                                                                                    </td>
                                                                                    <td
                                                                                        *ngIf="items.coopType == '2' && year_now < 2565 ">
                                                                                        {{TypeLevel4_type2 |
                                                                                        number:'':'he'}}
                                                                                    </td>
                                                                                    <td
                                                                                        *ngIf="items.coopType == '3' && year_now < 2565 ">
                                                                                        {{TypeLevel4_type3 |
                                                                                        number:'':'he'}}
                                                                                    </td>
                                                                                    <td
                                                                                        *ngIf="items.coopType == '4' && year_now < 2565 ">
                                                                                        {{TypeLevel4_type4 |
                                                                                        number:'':'he'}}
                                                                                    </td>
                                                                                    <td
                                                                                        *ngIf="items.coopType == '5' && year_now < 2565 ">
                                                                                        {{TypeLevel4_type5 |
                                                                                        number:'':'he'}}
                                                                                    </td>
                                                                                    <td
                                                                                        *ngIf="items.coopType == '6' && year_now < 2565 ">
                                                                                        {{TypeLevel4_type6 |
                                                                                        number:'':'he'}}
                                                                                    </td>
                                                                                    <td
                                                                                        *ngIf="items.coopType == '7' && year_now < 2565 ">
                                                                                        {{TypeLevel4_type7 |
                                                                                        number:'':'he'}}
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </ng-container>
                                            </div>

                                            <div class="row">
                                                <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                    <div class="card h-100">
                                                        <div class="card-header pb-0">
                                                            <h6 class="font-weight-bold">สินทรัพย์ของสหกรณ์
                                                            </h6>
                                                        </div>
                                                        <div class="card-body p-0">
                                                            <div class="col-xl-12 p-0">
                                                                <div id="chartdiv_asset"></div>
                                                            </div>
                                                            <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                <a href="" data-toggle="modal" data-target="#asset1info"
                                                                    (click)="asset1info()">ดูเพิ่มเติม</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                    <div class="card h-100">
                                                        <div class="card-header pb-0">
                                                            <h6 class="font-weight-bold">หนี้สินของสหกรณ์
                                                            </h6>
                                                        </div>
                                                        <div class="card-body p-0">
                                                            <div class="col-xl-12 p-0">
                                                                <div id="chartdiv_debt">
                                                                </div>
                                                            </div>
                                                            <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                <a href="" data-toggle="modal" data-target="#asset2info"
                                                                    (click)="asset2info()">ดูเพิ่มเติม</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                    <div class="card h-100">
                                                        <div class="card-header pb-0">
                                                            <h6 class="font-weight-bold">ทุนของสหกรณ์
                                                            </h6>
                                                        </div>
                                                        <div class="card-body p-0">
                                                            <div class="col-xl-12 p-0">
                                                                <div id="chartdiv_Capital">
                                                                </div>
                                                            </div>
                                                            <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                <a href="" data-toggle="modal" data-target="#asset3info"
                                                                    (click)="asset3info()">ดูเพิ่มเติม</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                    <div class="card h-100">
                                                        <div class="card-header pb-0">
                                                            <h6 class="font-weight-bold">กำไร(ขาดทุน)ของสหกรณ์
                                                            </h6>
                                                        </div>
                                                        <div class="card-body p-0">
                                                            <div class="col-xl-12 p-0">
                                                                <div id="chartdiv_profit">
                                                                </div>
                                                            </div>
                                                            <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                <a href="" data-toggle="modal" data-target="#asset4info"
                                                                    (click)="asset4info()">ดูเพิ่มเติม</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4" *ngIf="sector_now == 0">
                                                    <div class="card h-100">
                                                        <div class="card-header pb-0">
                                                            <h6 class="font-weight-bold">ปริมาณธุรกิจ
                                                            </h6>
                                                        </div>
                                                        <div class="card-body p-0">
                                                            <div class="col-xl-12">
                                                                <div id="chartdiv_business"></div>
                                                            </div>
                                                            <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                <a href="" data-toggle="modal" data-target="#myModal"
                                                                    (click)="myModal()">ดูเพิ่มเติม</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <ng-container *ngIf="sector_now == 0 || sector_now == 1">
                                                    <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                        <div class="card h-100">
                                                            <div class="card-header pb-0">
                                                                <h6 class="font-weight-bold">ปริมาณธุรกิจ
                                                                    ประเภทสหกรณ์การเกษตร
                                                                </h6>
                                                            </div>
                                                            <div class="card-body p-0">
                                                                <div class="col-xl-12">
                                                                    <div id="chartdiv_business_type1"></div>
                                                                </div>
                                                                <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                    <a href="" data-toggle="modal" data-target="#Type1"
                                                                        (click)="Type1()">ดูเพิ่มเติม</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                        <div class="card h-100">
                                                            <div class="card-header pb-0">
                                                                <h6 class="font-weight-bold">ปริมาณธุรกิจ ประเภทสหกรณ์ประมง
                                                                </h6>
                                                            </div>
                                                            <div class="card-body p-0">
                                                                <div class="col-xl-12">
                                                                    <div id="chartdiv_business_type2"></div>
                                                                </div>
                                                                <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                    <a href="" data-toggle="modal" data-target="#Type2"
                                                                        (click)="Type2()">ดูเพิ่มเติม</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                        <div class="card h-100">
                                                            <div class="card-header pb-0">
                                                                <h6 class="font-weight-bold">ปริมาณธุรกิจ ประเภทสหกรณ์นิคม
                                                                </h6>
                                                            </div>
                                                            <div class="card-body p-0">
                                                                <div class="col-xl-12">
                                                                    <div id="chartdiv_business_type3"></div>
                                                                </div>
                                                                <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                    <a href="" data-toggle="modal" data-target="#Type3"
                                                                        (click)="Type3()">ดูเพิ่มเติม</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </ng-container>
                                                <ng-container *ngIf="sector_now == 0 || sector_now == 2">
                                                    <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                        <div class="card h-100">
                                                            <div class="card-header pb-0">
                                                                <h6 class="font-weight-bold">ปริมาณธุรกิจ
                                                                    ประเภทสหกรณ์ออมทรัพย์
                                                                </h6>
                                                            </div>
                                                            <div class="card-body p-0">
                                                                <div class="col-xl-12">
                                                                    <div id="chartdiv_business_type4"></div>
                                                                </div>
                                                                <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                    <a href="" data-toggle="modal" data-target="#Type4"
                                                                        (click)="Type4()">ดูเพิ่มเติม</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                        <div class="card h-100">
                                                            <div class="card-header pb-0">
                                                                <h6 class="font-weight-bold">ปริมาณธุรกิจ
                                                                    ประเภทสหกรณ์ร้านค้า
                                                                </h6>
                                                            </div>
                                                            <div class="card-body p-0">
                                                                <div class="col-xl-12">
                                                                    <div id="chartdiv_business_type5"></div>
                                                                </div>
                                                                <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                    <a href="" data-toggle="modal" data-target="#Type5"
                                                                        (click)="Type5()">ดูเพิ่มเติม</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                        <div class="card h-100">
                                                            <div class="card-header pb-0">
                                                                <h6 class="font-weight-bold">ปริมาณธุรกิจ ประเภทสหกรณ์บริการ
                                                                </h6>
                                                            </div>
                                                            <div class="card-body p-0">
                                                                <div class="col-xl-12">
                                                                    <div id="chartdiv_business_type6"></div>
                                                                </div>
                                                                <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                    <a href="" data-toggle="modal" data-target="#Type6"
                                                                        (click)="Type6()">ดูเพิ่มเติม</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                        <div class="card h-100">
                                                            <div class="card-header pb-0">
                                                                <h6 class="font-weight-bold">ปริมาณธุรกิจ
                                                                    ประเภทสหกรณ์เครดิตยูเนี่ยน
                                                                </h6>
                                                            </div>
                                                            <div class="card-body p-0">
                                                                <div class="col-xl-12">
                                                                    <div id="chartdiv_business_type7"></div>
                                                                </div>
                                                                <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                    <a href="" data-toggle="modal" data-target="#Type7"
                                                                        (click)="Type7()">ดูเพิ่มเติม</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </ng-container>
                                            </div>

                                            <div class="row">
                                                <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4" *ngIf="sector_now == 0">
                                                    <div class="card h-100">
                                                        <div class="card-header pb-0">
                                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                                                ทุกประเภทสหกรณ์
                                                            </h6>
                                                        </div>
                                                        <div class="card-body">
                                                            <div id="chartdiv_Participation_coop_sum">
                                                            </div>
                                                            <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                <a href="" data-toggle="modal"
                                                                    data-target="#Participation"
                                                                    (click)="Participation()">ดูเพิ่มเติม</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <ng-container *ngIf="sector_now == 0 || sector_now == 1">
                                                    <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                        <div class="card h-100">
                                                            <div class="card-header pb-0">
                                                                <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                                                    ประเภทการเกษตร
                                                                </h6>
                                                            </div>
                                                            <div class="card-body">
                                                                <div id="chartdiv_Participation_coop">
                                                                </div>
                                                                <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                    <a href="" data-toggle="modal"
                                                                        data-target="#Participation1"
                                                                        (click)="Participation1()">ดูเพิ่มเติม</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                        <div class="card h-100">
                                                            <div class="card-header pb-0">
                                                                <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                                                    ประเภทประมง
                                                                </h6>
                                                            </div>
                                                            <div class="card-body">
                                                                <div id="chartdiv_Participation_fishing">
                                                                </div>
                                                                <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                    <a href="" data-toggle="modal"
                                                                        data-target="#Participation2"
                                                                        (click)="Participation2()">ดูเพิ่มเติม</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                        <div class="card h-100">
                                                            <div class="card-header pb-0">
                                                                <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                                                    ประเภทนิคม
                                                                </h6>
                                                            </div>
                                                            <div class="card-body">
                                                                <div id="chartdiv_Participation_Settlement">
                                                                </div>
                                                                <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                    <a href="" data-toggle="modal"
                                                                        data-target="#Participation3"
                                                                        (click)="Participation3()">ดูเพิ่มเติม</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </ng-container>
                                                <ng-container *ngIf="sector_now == 0 || sector_now == 2">
                                                    <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                        <div class="card h-100">
                                                            <div class="card-header pb-0">
                                                                <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                                                    ประเภทออมทรัพย์
                                                                </h6>
                                                            </div>
                                                            <div class="card-body">
                                                                <div id="chartdiv_Participation_saving">
                                                                </div>
                                                                <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                    <a href="" data-toggle="modal"
                                                                        data-target="#Participation4"
                                                                        (click)="Participation4()">ดูเพิ่มเติม</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                        <div class="card h-100">
                                                            <div class="card-header pb-0">
                                                                <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                                                    ประเภทร้านค้า
                                                                </h6>
                                                            </div>
                                                            <div class="card-body">
                                                                <div id="chartdiv_Participation_shop">
                                                                </div>
                                                                <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                    <a href="" data-toggle="modal"
                                                                        data-target="#Participation5"
                                                                        (click)="Participation5()">ดูเพิ่มเติม</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                        <div class="card h-100">
                                                            <div class="card-header pb-0">
                                                                <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                                                    ประเภทบริการ
                                                                </h6>
                                                            </div>
                                                            <div class="card-body">
                                                                <div id="chartdiv_Participation_service">
                                                                </div>
                                                                <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                    <a href="" data-toggle="modal"
                                                                        data-target="#Participation6"
                                                                        (click)="Participation6()">ดูเพิ่มเติม</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                        <div class="card h-100">
                                                            <div class="card-header pb-0">
                                                                <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                                                    ประเภทเครดิตยูเนี่ยน
                                                                </h6>
                                                            </div>
                                                            <div class="card-body">
                                                                <div id="chartdiv_Participation_credit">
                                                                </div>
                                                                <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                    <a href="" data-toggle="modal"
                                                                        data-target="#Participation7"
                                                                        (click)="Participation7()">ดูเพิ่มเติม</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </ng-container>
                                            </div>

                                            <div class="row">
                                                <!--  -->
                                                <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4"
                                                    *ngIf="ViewOAE_1">
                                                    <div class="card h-100">
                                                        <div class="card-header
                                                            pb-0">
                                                            <h6 class="font-weight-bold">ทะเบียนเกษตรกร
                                                            </h6>
                                                        </div>
                                                        <div class="card-body p-3">
                                                            <div class="row p-0 mt-2 text-center">
                                                                <div class="col-xl-4">
                                                                    <img src="/assets/images/farmer-m.png"
                                                                        class="img-staff" alt="">
                                                                </div>
                                                                <div class="col-xl-8 mt-auto mb-auto">
                                                                    <span class="content-user2">จำนวนคน</span>
                                                                    <p class="content-user3 mt-auto mb-auto">
                                                                        {{ViewOAE_1.total_count}}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="row p-0 mt-2 text-center">
                                                                <div class="col-xl-4">
                                                                    <img src="/assets/images/icon_land.png"
                                                                        class="img-staff" alt="">
                                                                </div>
                                                                <div class="col-xl-8 mt-auto mb-auto">
                                                                    <span class="content-user2">จำนวนพื้นที่
                                                                        (ไร่)</span>
                                                                    <p class="content-user3 mt-auto mb-auto">
                                                                        {{ViewOAE_1.total_rai}}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                <a href="" data-toggle="collapse"
                                                                    data-target="#collapse1"
                                                                    (click)="GetViewOAEDetailByGroup('1')">ดูเพิ่มเติม</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4"
                                                    *ngIf="ViewOAE_2">
                                                    <div class="card h-100">
                                                        <div class="card-header
                                                            pb-0">
                                                            <h6 class="font-weight-bold">ทะเบียนเลี้ยงสัตว์
                                                            </h6>
                                                        </div>
                                                        <div class="card-body p-3">
                                                            <div class="row p-0 mt-2 text-center">
                                                                <div class="col-xl-4">
                                                                    <img src="/assets/images/farmer-m.png"
                                                                        class="img-staff" alt="">
                                                                </div>
                                                                <div class="col-xl-8 mt-auto mb-auto">
                                                                    <span class="content-user2">จำนวนคน</span>
                                                                    <p class="content-user3 mt-auto mb-auto">
                                                                        {{ViewOAE_2.total_count}}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="row p-0 mt-2 text-center">
                                                                <div class="col-xl-4">
                                                                    <img src="/assets/images/icon_land.png"
                                                                        class="img-staff" alt="">
                                                                </div>
                                                                <div class="col-xl-8 mt-auto mb-auto">
                                                                    <span class="content-user2">จำนวนพื้นที่
                                                                        (ไร่)</span>
                                                                    <p class="content-user3 mt-auto mb-auto">
                                                                        {{ViewOAE_2.total_rai}}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                <a href="" data-toggle="collapse"
                                                                    data-target="#collapse2"
                                                                    (click)="GetViewOAEDetailByGroup('2')">ดูเพิ่มเติม</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4"
                                                    *ngIf="ViewOAE_3">
                                                    <div class="card h-100">
                                                        <div class="card-header
                                                            pb-0">
                                                            <h6 class="font-weight-bold">ทะเบียนประมง
                                                            </h6>
                                                        </div>
                                                        <div class="card-body p-3">
                                                            <div class="row p-0 mt-2 text-center">
                                                                <div class="col-xl-4">
                                                                    <img src="/assets/images/farmer-m.png"
                                                                        class="img-staff" alt="">
                                                                </div>
                                                                <div class="col-xl-8 mt-auto mb-auto">
                                                                    <span class="content-user2">จำนวนคน</span>
                                                                    <p class="content-user3 mt-auto mb-auto">
                                                                        {{ViewOAE_3.total_count}}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="row p-0 mt-2 text-center">
                                                                <div class="col-xl-4">
                                                                    <img src="/assets/images/icon_land.png"
                                                                        class="img-staff" alt="">
                                                                </div>
                                                                <div class="col-xl-8 mt-auto mb-auto">
                                                                    <span class="content-user2">จำนวนพื้นที่
                                                                        (ไร่)</span>
                                                                    <p class="content-user3 mt-auto mb-auto">
                                                                        {{ViewOAE_3.total_rai}}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                <a href="" data-toggle="collapse"
                                                                    data-target="#collapse3"
                                                                    (click)="GetViewOAEDetailByGroup('3')">ดูเพิ่มเติม</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4"
                                                    *ngIf="rubber_sum">
                                                    <div class="card h-100">
                                                        <div class="card-header
                                                            pb-0">
                                                            <h6 class="font-weight-bold">ทะเบียนผู้ปลูกยาง
                                                            </h6>
                                                        </div>
                                                        <div class="card-body p-3">
                                                            <div class="row p-0 mt-2 text-center">
                                                                <div class="col-xl-4">
                                                                    <img src="/assets/images/farmer-m.png"
                                                                        class="img-staff" alt="">
                                                                </div>
                                                                <div class="col-xl-8 mt-auto mb-auto">
                                                                    <span class="content-user2">จำนวนคน</span>
                                                                    <p class="content-user3 mt-auto mb-auto">
                                                                        {{rubber_sum.total_count}}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="row p-0 mt-2 text-center">
                                                                <div class="col-xl-4">
                                                                    <img src="/assets/images/icon_land.png"
                                                                        class="img-staff" alt="">
                                                                </div>
                                                                <div class="col-xl-8 mt-auto mb-auto">
                                                                    <span class="content-user2">จำนวนพื้นที่
                                                                        (ไร่)</span>
                                                                    <p class="content-user3 mt-auto mb-auto">
                                                                        {{rubber_sum.total_rai}}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <!-- <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                <a href="" data-toggle="modal"
                                                                    data-target="#Participation11"
                                                                    (click)="Participation11()">ดูเพิ่มเติม</a>
                                                            </div> -->
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="accordion collapse-zone" id="accordion">
                                                    <div class="collapse collapse-zone" id="collapse1"
                                                        data-parent="#accordion">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-4">
                                                            <div class="card card-body p-2">
                                                                <table class="table table-hover">
                                                                    <thead>
                                                                        <tr class="table-active text-center">
                                                                            <th scope="col"></th>
                                                                            <th scope="col" style="font-size: 15px;">
                                                                                ลำดับ</th>
                                                                            <th scope="col" style="font-size: 15px;">
                                                                                ประเภท</th>
                                                                            <th scope="col" style="font-size: 15px;">
                                                                                จำนวนสมาชิก (คน)</th>
                                                                            <th scope="col" style="font-size: 15px;">
                                                                                พื้นที่เพาะปลูก (ไร่)</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <th scope="row" colspan="5"
                                                                        class="font-weight-bold table-active">
                                                                        ทะเบียนเกษตรกร
                                                                    </th>
                                                                    <tbody
                                                                        *ngFor="let items of ViewOAE_1_detail; index as i">
                                                                        <tr>
                                                                            <th></th>
                                                                            <td scope="row" class="table-active"
                                                                                style="font-size: 15px;">{{i+1}}</td>
                                                                            <td scope="row" style="font-size: 15px;">
                                                                                {{items.type}}</td>
                                                                            <td scope="row" style="font-size: 15px;">
                                                                                {{items.total_count}} </td>
                                                                            <td scope="row" style="font-size: 15px;">
                                                                                {{items.total_rai}} </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="collapse collapse-zone" id="collapse2"
                                                        data-parent="#accordion">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-4">
                                                            <div class="card card-body p-2">
                                                                <table class="table table-hover">
                                                                    <thead>
                                                                        <tr class="table-active text-center">
                                                                            <th scope="col"></th>
                                                                            <th scope="col" style="font-size: 15px;">
                                                                                ลำดับ</th>
                                                                            <th scope="col" style="font-size: 15px;">
                                                                                ประเภท</th>
                                                                            <th scope="col" style="font-size: 15px;">
                                                                                จำนวนสมาชิก (คน)</th>
                                                                            <th scope="col" style="font-size: 15px;">
                                                                                พื้นที่เพาะปลูก (ไร่)</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <th scope="row" colspan="5"
                                                                        class="font-weight-bold table-active">
                                                                        ทะเบียนเลี้ยงสัตว์
                                                                    </th>
                                                                    <tbody
                                                                        *ngFor="let items of ViewOAE_2_detail; index as i">
                                                                        <tr>
                                                                            <th></th>
                                                                            <td scope="row" class="table-active"
                                                                                style="font-size: 15px;">{{i+1}}</td>
                                                                            <td scope="row" style="font-size: 15px;">
                                                                                {{items.typeDetail}}</td>
                                                                            <td scope="row" style="font-size: 15px;">
                                                                                {{items.total_count}} </td>
                                                                            <td scope="row" style="font-size: 15px;">
                                                                                {{items.total_rai}} </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="collapse collapse-zone" id="collapse3"
                                                        data-parent="#accordion">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-4">
                                                            <div class="card card-body p-2">
                                                                <table class="table table-hover">
                                                                    <thead>
                                                                        <tr class="table-active text-center">
                                                                            <th scope="col"></th>
                                                                            <th scope="col" style="font-size: 15px;">
                                                                                ลำดับ</th>
                                                                            <th scope="col" style="font-size: 15px;">
                                                                                ประเภท</th>
                                                                            <th scope="col" style="font-size: 15px;">
                                                                                จำนวนสมาชิก (คน)</th>
                                                                            <th scope="col" style="font-size: 15px;">
                                                                                พื้นที่เพาะปลูก (ไร่)</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <th scope="row" colspan="5"
                                                                        class="font-weight-bold table-active">
                                                                        ทะเบียนประมง
                                                                    </th>
                                                                    <tbody
                                                                        *ngFor="let items of ViewOAE_3_detail; index as i">
                                                                        <tr>
                                                                            <th></th>
                                                                            <td scope="row" class="table-active"
                                                                                style="font-size: 15px;">{{i+1}}</td>
                                                                            <td scope="row" style="font-size: 15px;">
                                                                                {{items.typeDetail}}</td>
                                                                            <td scope="row" style="font-size: 15px;">
                                                                                {{items.total_count}} </td>
                                                                            <td scope="row" style="font-size: 15px;">
                                                                                {{items.total_rai}} </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                            <div class="row" *ngIf="defect_on == true && verify_defect == true">
                                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-4">
                                                    <div class="card h-100">
                                                        <div class="card-header pb-0">
                                                            <h6 class="font-weight-bold">ข้อบกพร่อง
                                                            </h6>
                                                        </div>
                                                        <div class="card-body p-0">
                                                            <div class="col-xl-12 mt-3">
                                                                <table class="table table-bordered">
                                                                    <thead class="thead-light text-center">
                                                                        <tr>
                                                                            <th>หัวข้อ</th>
                                                                            <th>ชื่อหัวข้อ</th>
                                                                            <th>จำนวนสหกรณ์</th>
                                                                            <th>มูลค่าความเสียหาย (บาท)</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr
                                                                            *ngFor="let defect of defect_data; let i = index">
                                                                            <td>{{i+1}}</td>
                                                                            <td>{{defect.defectMainName}}</td>
                                                                            <td>{{defect.numCoopDefect}}</td>
                                                                            <td>{{defect.lossValue}}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div id="asset_" class="tab-pane fade">
                                        <!-- เพิ่มหน้าสำหรับ อุปกรณ์การตลาดของจังหวัด -->
                                        <app-coop-assets></app-coop-assets>
                                    </div>
                                    <div id="machine_" class="tab-pane fade">
                                        <!-- เครื่องจักรกลการเกษตรของจังหวัด -->
                                        <app-coop-machine></app-coop-machine>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="List">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                        <p class="conotent-year text-black-50">
                            ภาคการเกษตร
                            <select class="form-select select_year mr-3" name="list_sector" id="list_sector"
                                (change)="selectNewYearAndSector('',$event.target.value)"
                                [(ngModel)]="sector_now">
                                <option *ngFor="let x of listsector" value="{{x.value}}">
                                    {{x.name}}</option>
                            </select>
                            ข้อมูล ณ ปี
                            <select class="form-select select_year" name="list_year" id="list_year"
                                (change)="selectNewYearAndSector($event.target.value,'')" [(ngModel)]="year_now">
                                <option *ngFor="let y of listYear" value="{{y}}">{{y}}</option>
                            </select>
                        </p>
                    </div>
                    <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                        <p class="text-right mt-2 mb-1">จำนวนผลลัพธ์การค้นหา : {{sumResult_}}
                        </p>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0">
                        <div class="card">
                            <div class="card-header p-2">
                                <div class="row">
                                    <div class="col-lg-8 col-md-12 col-sm-12">
                                        <h6 class="m-0">รายชื่อสหกรณ์</h6>
                                    </div>
                                    <div class="col-lg-4 col-md-12 col-sm-12">
                                    </div>
                                </div>
                            </div>
                            <div class="card-body p-4">
                                <div class="form-group row">
                                    <div class="col-xl-3 col-lg-3 col-md-12
                                        col-sm-12">
                                        <label for="inputPassword" class="col-form-label">ค้นหารายการ</label>
                                    </div>
                                    <div class="col-xl-9 col-lg-9 col-md-12
                                        col-sm-12">
                                        <input class="form-control w-100" type="text" name="search"
                                            [(ngModel)]="searchText">
                                    </div>
                                </div>

                                <div class="table-responsive">
                                    <table class="table table-hover">
                                        <thead>
                                            <tr class="table-active text-center">
                                                <th width="30%">ชื่อสหกรณ์</th>
                                                <th scope="col">รหัสสหกรณ์</th>
                                                <th scope="col">มาตรฐานสหกรณ์</th>
                                                <th scope="col">สมาชิกสหกรณ์ ทั้งหมด
                                                </th>
                                                <th width="10%">เพิ่มเติม</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let items of
                                                listCoop |
                                                filter:searchText; let i = index">
                                                <th scope="row">{{items.coopNameTh || '-'}}</th>
                                                <td>{{items.registryNo2|| '-'}}</td>
                                                <td *ngIf="items.stdCode == '1'">ผ่านมาตรฐานสหกรณ์</td>
                                                <td *ngIf="items.stdCode == '2'">ไม่ผ่านมาตรฐานสหกรณ์</td>
                                                <td *ngIf="items.stdCode == '3'">ไม่นำมาจัดมาตรฐานสหกรณ์</td>
                                                <td *ngIf="items.stdCode == ' '">-</td>

                                                <td class="text-center">{{items.member}}</td>
                                                <td>
                                                    <button class="btn btn-info"
                                                        (click)="selectCoopProfile(items.coopNameTh)">
                                                        <i class="fa fa-search" aria-hidden="true"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="card-footer">
                                <!-- <jw-pagination [items]="listCoop" (changePage)="onChangePage($event)"></jw-pagination> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
    <app-footer></app-footer>
</div>

<div class="container">
    <div id="myModal" class="modal fade" role="dialog">
        <div class="modal-dialog col-12">
            <!-- Modal content-->
            <div class="modal-content col-12">
                <div class="modal-header">
                    <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจ ประเภทรับฝากเงิน</h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_deposit"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจ ประเภทให้เงินกู้
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_lend"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจ ประเภทจัดหาสินค้ามาจำหน่าย

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_products"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจ ประเภทรวบรวมผลผลิต</h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_produce"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจ ประเภทแปรรูปผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_Processing"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจ ประเภทบริการ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_service"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

    <div id="Type1" class="modal fade" role="dialog">
        <div class="modal-dialog col-12">
            <!-- Modal content-->
            <div class="modal-content col-12">
                <div class="modal-header">
                    <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์การเกษตร ประเภทรับฝากเงิน</h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type1_deposit_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์การเกษตร ประเภทให้เงินกู้
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type1_credit_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์การเกษตร ประเภทจัดหาสินค้ามาจำหน่าย

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type1_sale_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์การเกษตร ประเภทรวบรวมผลผลิต</h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type1_collect_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header
                            pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์การเกษตร ประเภทแปรรูปผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body
                            p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type1_transfrom_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header
                        pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์การเกษตร ประเภทบริการ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type1_service_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

    <div id="Type2" class="modal fade" role="dialog">
        <div class="modal-dialog col-12">
            <!-- Modal content-->
            <div class="modal-content col-12">
                <div class="modal-header">
                    <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์การเกษตร ประเภทรับฝากเงิน</h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type2_deposit_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์การเกษตร ประเภทให้เงินกู้
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type2_credit_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์การเกษตร ประเภทจัดหาสินค้ามาจำหน่าย

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type2_sale_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์การเกษตร ประเภทรวบรวมผลผลิต</h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type2_collect_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header
                            pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์การเกษตร ประเภทแปรรูปผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body
                            p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type2_transfrom_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header
                        pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์การเกษตร ประเภทบริการ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type2_service_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

    <div id="Type3" class="modal fade" role="dialog">
        <div class="modal-dialog col-12">
            <!-- Modal content-->
            <div class="modal-content col-12">
                <div class="modal-header">
                    <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์นิคม ประเภทรับฝากเงิน</h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type3_deposit_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์นิคม ประเภทให้เงินกู้
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type3_credit_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์นิคม ประเภทจัดหาสินค้ามาจำหน่าย

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type3_sale_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์นิคม ประเภทรวบรวมผลผลิต</h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type3_collect_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์นิคม ประเภทแปรรูปผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type3_transfrom_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์นิคม ประเภทบริการ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type3_service_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

    <div id="Type4" class="modal fade" role="dialog">
        <div class="modal-dialog col-12">
            <!-- Modal content-->
            <div class="modal-content col-12">
                <div class="modal-header">
                    <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์ออมทรัพย์ ประเภทรับฝากเงิน</h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type4_deposit_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์ออมทรัพย์ ประเภทให้เงินกู้
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type4_credit_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์ออมทรัพย์ ประเภทจัดหาสินค้ามาจำหน่าย

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type4_sale_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์ออมทรัพย์ ประเภทรวบรวมผลผลิต</h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type4_collect_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์ออมทรัพย์ ประเภทแปรรูปผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type4_transfrom_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์ออมทรัพย์ ประเภทบริการ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type4_service_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

    <div id="Type5" class="modal fade" role="dialog">
        <div class="modal-dialog col-12">
            <!-- Modal content-->
            <div class="modal-content col-12">
                <div class="modal-header">
                    <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทรับฝากเงิน</h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type5_deposit_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทให้เงินกู้
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type5_credit_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทจัดหาสินค้ามาจำหน่าย

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type5_sale_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทรวบรวมผลผลิต</h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type5_collect_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทแปรรูปผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type5_transfrom_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทบริการ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type5_service_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

    <div id="Type6" class="modal fade" role="dialog">
        <div class="modal-dialog col-12">
            <!-- Modal content-->
            <div class="modal-content col-12">
                <div class="modal-header">
                    <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์บริการ ประเภทรับฝากเงิน</h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type6_deposit_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์บริการ ประเภทให้เงินกู้
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type6_credit_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์บริการ ประเภทจัดหาสินค้ามาจำหน่าย

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type6_sale_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์บริการ ประเภทรวบรวมผลผลิต</h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type6_collect_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์บริการ ประเภทแปรรูปผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type6_transfrom_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์บริการ ประเภทบริการ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type6_service_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

    <div id="Type7" class="modal fade" role="dialog">
        <div class="modal-dialog col-12">
            <!-- Modal content-->
            <div class="modal-content col-12">
                <div class="modal-header">
                    <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์เครดิตยูเนี่ยน ประเภทรับฝากเงิน</h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type7_deposit_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์เครดิตยูเนี่ยน ประเภทให้เงินกู้
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type7_credit_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์เครดิตยูเนี่ยน
                                        ประเภทจัดหาสินค้ามาจำหน่าย

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type7_sale_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์เครดิตยูเนี่ยน ประเภทรวบรวมผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type7_collect_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header
                            pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์เครดิตยูเนี่ยน ประเภทแปรรูปผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body
                            p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type7_transfrom_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header
                        pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์เครดิตยูเนี่ยน ประเภทบริการ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type7_service_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

    <div id="asset1info" class="modal fade" role="dialog">
        <div class="modal-dialog col-12">
            <!-- Modal content-->
            <div class="modal-content col-12">
                <div class="modal-header">
                    <h6 class="font-weight-bold">สินทรัพย์ของสหกรณ์ ประเภทสหกรณ์
                    </h6>
                    <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-12 mt-4">
                            <div class="row">
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">สหกรณ์การเกษตร
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_asset_type1_info">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">สหกรณ์ประมง
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_asset_type2_info">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">สหกรณ์นิคม
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_asset_type3_info">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">สหกรณ์ออมทรัพย์
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_asset_type4_info">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">สหกรณ์ร้านค้า
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_asset_type5_info">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">สหกรณ์บริการ
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_asset_type6_info">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card  h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">
                                                สหกรณ์เครดิตยูเนี่ยน
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_asset_type7_info">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

    <div id="asset2info" class="modal fade" role="dialog">
        <div class="modal-dialog col-12">
            <!-- Modal content-->
            <div class="modal-content col-12">
                <div class="modal-header">
                    <h6 class="font-weight-bold">หนี้สินของสหกรณ์ ประเภทสหกรณ์
                    </h6>
                    <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-12 mt-4">
                            <div class="row">
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">สหกรณ์การเกษตร
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_debt_type1_info">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">สหกรณ์ประมง
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_debt_type2_info">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">สหกรณ์นิคม
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_debt_type3_info">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">สหกรณ์ออมทรัพย์
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_debt_type4_info">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">สหกรณ์ร้านค้า
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_debt_type5_info">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">สหกรณ์บริการ
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_debt_type6_info">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">
                                                สหกรณ์เครดิตยูเนี่ยน
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_debt_type7_info">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

    <div id="asset3info" class="modal fade" role="dialog">
        <div class="modal-dialog col-12">
            <!-- Modal content-->
            <div class="modal-content col-12">
                <div class="modal-header">
                    <h6 class="font-weight-bold">ทุนของสหกรณ์ ประเภทสหกรณ์
                    </h6>
                    <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-12 mt-4">
                            <div class="row">
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">สหกรณ์การเกษตร
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_Capital_type1_info">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">สหกรณ์ประมง
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_Capital_type2_info">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">สหกรณ์นิคม
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_Capital_type3_info">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">สหกรณ์ออมทรัพย์
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_Capital_type4_info">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">สหกรณ์ร้านค้า
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_Capital_type5_info">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">สหกรณ์บริการ
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_Capital_type6_info">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">
                                                สหกรณ์เครดิตยูเนี่ยน
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_Capital_type7_info">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

    <div id="asset4info" class="modal fade" role="dialog">
        <div class="modal-dialog col-12">
            <!-- Modal content-->
            <div class="modal-content col-12">
                <div class="modal-header">
                    <h6 class="font-weight-bold">กำไร (ขาดทุน)สหกรณ์
                        ประเภทสหกรณ์
                    </h6>
                    <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-12 mt-4">
                            <div class="row">
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">สหกรณ์การเกษตร
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_profit_type1_info">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">สหกรณ์ประมง
                                            </h6>
                                        </div>
                                        <div class="card-body  p-0">
                                            <div id="chartdiv_profit_type2_info">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">สหกรณ์นิคม
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_profit_type3_info">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">สหกรณ์ออมทรัพย์
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_profit_type4_info">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">สหกรณ์ร้านค้า
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_profit_type5_info">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">สหกรณ์บริการ
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_profit_type6_info">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">
                                                สหกรณ์เครดิตยูเนี่ยน
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_profit_type7_info">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

    <div id="Participation" class="modal fade" role="dialog">
        <div class="modal-dialog col-12">
            <!-- Modal content-->
            <div class="modal-content col-12">
                <div class="modal-header">
                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์ ทุกประเภทสหกรณ์
                    </h6>
                    <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                        ประเภทรับฝากเงิน
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_deposit_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                        ประเภทให้เงินกู้
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_credit_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                        ประเภทจัดหาสินค้ามาจำหน่าย
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_sale_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                        ประเภทรวบรวมผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_collect_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                        ประเภทแปรรูปผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_transfrom_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_service_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_other_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

    <div id="Participation1" class="modal fade" role="dialog">
        <div class="modal-dialog col-12">
            <!-- Modal content-->
            <div class="modal-content col-12">
                <div class="modal-header">
                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทสหกรณ์การเกษตร
                    </h6>
                    <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                        ประเภทรับฝากเงิน
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type1_deposit_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                        ประเภทให้เงินกู้
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type1_credit_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                        ประเภทจัดหาสินค้ามาจำหน่าย
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type1_sale_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                        ประเภทรวบรวมผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type1_collect_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                        ประเภทแปรรูปผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type1_transfrom_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type1_service_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type1_other_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

    <div id="Participation2" class="modal fade" role="dialog">
        <div class="modal-dialog col-12">
            <!-- Modal content-->
            <div class="modal-content col-12">
                <div class="modal-header">
                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทสหกรณ์ประมง
                    </h6>
                    <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                        ประเภทรับฝากเงิน
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type2_deposit_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                        ประเภทให้เงินกู้
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type2_credit_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                        ประเภทจัดหาสินค้ามาจำหน่าย
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type2_sale_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                        ประเภทรวบรวมผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type2_collect_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                        ประเภทแปรรูปผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type2_transfrom_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type2_service_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type2_other_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

    <div id="Participation3" class="modal fade" role="dialog">
        <div class="modal-dialog col-12">
            <!-- Modal content-->
            <div class="modal-content col-12">
                <div class="modal-header">
                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทสหกรณ์นิคม
                    </h6>
                    <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                        ประเภทรับฝากเงิน
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type3_deposit_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                        ประเภทให้เงินกู้
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type3_credit_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                        ประเภทจัดหาสินค้ามาจำหน่าย
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type3_sale_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                        ประเภทรวบรวมผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type3_collect_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                        ประเภทแปรรูปผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type3_transfrom_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type3_service_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type3_other_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

    <div id="Participation4" class="modal fade" role="dialog">
        <div class="modal-dialog col-12">
            <!-- Modal content-->
            <div class="modal-content col-12">
                <div class="modal-header">
                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทสหกรณ์ออมทรัพย์
                    </h6>
                    <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                        ประเภทรับฝากเงิน
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type4_deposit_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                        ประเภทให้เงินกู้
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type4_credit_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                        ประเภทจัดหาสินค้ามาจำหน่าย
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type4_sale_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                        ประเภทรวบรวมผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type4_collect_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                        ประเภทแปรรูปผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type4_transfrom_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type4_service_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type4_other_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

    <div id="Participation5" class="modal fade" role="dialog">
        <div class="modal-dialog col-12">
            <!-- Modal content-->
            <div class="modal-content col-12">
                <div class="modal-header">
                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทสหกรณ์ร้านค้า
                    </h6>
                    <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                        ประเภทรับฝากเงิน
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type5_deposit_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                        ประเภทให้เงินกู้
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type5_credit_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                        ประเภทจัดหาสินค้ามาจำหน่าย
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type5_sale_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                        ประเภทรวบรวมผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type5_collect_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                        ประเภทแปรรูปผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type5_transfrom_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type5_service_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type5_other_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

    <div id="Participation6" class="modal fade" role="dialog">
        <div class="modal-dialog col-12">
            <!-- Modal content-->
            <div class="modal-content col-12">
                <div class="modal-header">
                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทสหกรณ์บริการ
                    </h6>
                    <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                        ประเภทรับฝากเงิน
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type6_deposit_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                        ประเภทให้เงินกู้
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type6_credit_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                        ประเภทจัดหาสินค้ามาจำหน่าย
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type6_sale_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                        ประเภทรวบรวมผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type6_collect_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                        ประเภทแปรรูปผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type6_transfrom_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type6_service_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type6_other_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

    <div id="Participation7" class="modal fade" role="dialog">
        <div class="modal-dialog col-12">
            <!-- Modal content-->
            <div class="modal-content col-12">
                <div class="modal-header">
                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทสหกรณ์เครดิตยูเนี่ยน
                    </h6>
                    <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                        ประเภทรับฝากเงิน
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type7_deposit_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                        ประเภทให้เงินกู้
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type7_credit_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                        ประเภทจัดหาสินค้ามาจำหน่าย
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type7_sale_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                        ประเภทรวบรวมผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type7_collect_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                        ประเภทแปรรูปผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type7_transfrom_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type7_service_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type7_other_val"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

</div>

<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white">กรุณารอสักครู่. </p>
</ngx-spinner>
